<app-loader [loading]="isLoading"></app-loader>
<div class="container-fluid p-0">
    <div class="row m-0">
        <div class="col-12 p-0">
            <div class="login-card login-dark">
                <div>
                    <div>
                        <a class="logo" [routerLink]="['/home']">
                            <img class="img-fluid for-light img-logo" src="assets/images/logo/logo.png" alt="loginPage">
                            <img class="img-fluid for-dark img-logo" src="assets/images/logo/logo.png" alt="loginPage">
                        </a>
                    </div>
                    <div class="login-main">
                        <form class="theme-form" [formGroup]="form" ngNativeValidate>
                            <h4>Add your Password</h4>
                            <div class="form-group">
                                <label class="col-form-label">Password</label>
                                <div class="form-input position-relative">
                                    <input class="form-control" formControlName="password" type="password"
                                        name="password" [type]="show ? 'password' : 'text'" required=""
                                        placeholder="*********" />
                                    <div class="show-hide">
                                        <span (click)="show = !show" [class.show]="show"></span>
                                    </div>
                                </div>
                                @if (validate && formValidation.isInvalidField(form,'password')) {
                                <div class="form-error">
                                    <div>{{formValidation.getErrorMessage(form,'password')}}</div>
                                </div>
                                }
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Repeat Password</label>
                                <div class="form-input position-relative">
                                    <input class="form-control" formControlName="confirmPassword" type="password"
                                        name="confirmPassword" [type]="showConfirm ? 'password' : 'text'" required=""
                                        placeholder="*********" />
                                    <div class="show-hide">
                                        <span (click)="showConfirm = !showConfirm" [class.show]="showConfirm"></span>
                                    </div>
                                </div>
                                @if (validate) {
                                <div class="form-error">
                                    <div>{{formValidation.getErrorComparePassword(form)}}</div>
                                </div>
                                }
                                @if (validate && formValidation.isInvalidField(form,'confirmPassword')) {
                                <div class="form-error">
                                    <div>{{formValidation.getErrorMessage(form,'confirmPassword')}}</div>
                                </div>
                                }
                            </div>
                            <div class="form-group mb-0">
                                <button class="btn btn-primary btn-block w-100" type="submit"
                                    (click)="activateAccount()">
                                    Activate account
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>